import React from 'react';
import ProductBand from '@v2/shared/components/ProductBand';
import SingleBanner from './SingleBanner';
import TopBanners from './TopBanners';
import WhyDiscountMags from './WhyDiscountMags';
import { Category, Banner } from '@v2/shared/lib/types';
import useUrlGenerator from '@v2/shared/lib/useUrlGenerator';
import SpecialDeals from './SpecialDeals';
import CompanyReviewScript from '@v2/shared/components/CompanyReviewScript';
import CompanyReviewWidget from './CompanyReviewWidget';
import SiteAwareHomeTitle from './SiteAwareHomeTitle';

export interface Props {
  categories: Category[];
  banners: Banner[];
}

export default function Home({ categories, banners }: Props) {
  const { buildUrl } = useUrlGenerator();

  // The box, its measure and its spacing are all Layouts.Full's.
  return (
    <>
      <TopBanners banners={banners} />
      <SiteAwareHomeTitle />
      {categories.map((category, key) => {
        const products = category.products ? category.products.slice(0, 15) : [];

        return (
          <div key={key}>
            {key === 2 && (
              <>
                <SingleBanner banner={banners[3]} />
                <SpecialDeals />
              </>
            )}
            <ProductBand
              title={category.name}
              products={products}
              viewAllLink={category.products && category.products.length > 15 ? buildUrl(category.href) : undefined}
            />
          </div>
        );
      })}
      <WhyDiscountMags />

      <CompanyReviewScript>
        <CompanyReviewWidget />
      </CompanyReviewScript>
    </>
  );
}

// Rendered inside Layouts.Full; the mount resolves it and passes it the layout props.
Home.layoutName = 'Layouts.Full';
